import { render, staticRenderFns } from "./AddressProviderChart.vue?vue&type=template&id=48f4abae&"
import script from "./AddressProviderChart.vue?vue&type=script&lang=js&"
export * from "./AddressProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports